import { FetchAPI } from '../Main/fetchAPI';
import { CLIENT } from '../constants';

export const RoleConfiguration = {
	getConfiguration: () =>
		FetchAPI.getJson({
			urlStr: `${CLIENT}/role-configuration`,
		}),
};
